import createReactComponent from '../createReactComponent';
export default createReactComponent('circuit-ammeter', 'IconCircuitAmmeter', [
  ['path', { d: 'M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0', key: 'svg-0' }],
  ['path', { d: 'M5 12h-3', key: 'svg-1' }],
  ['path', { d: 'M19 12h3', key: 'svg-2' }],
  ['path', { d: 'M10 14v-3c0 -1.036 .895 -2 2 -2s2 .964 2 2v3', key: 'svg-3' }],
  ['path', { d: 'M14 12h-4', key: 'svg-4' }],
]);
